import PinWithAddPhone from '@molecules/PinWithAddPhone';
import { addPhoneTemplate3 } from '@root/constants';
import { AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { filterRejected } from '@utils/utils';
import React from 'react';
import logPhonePage from './analyticsPhoneEnrolled';

interface PhoneData {
  status: string;
}

export function onCompleteGetPhoneCallBack(
  data: PhoneData[],
  setPhoneList: (list: PhoneData[]) => void,
  isTransact: boolean,
  eventSource: string,
  transactionCategoryId?: string | number,
): void {
  const filtered = filterRejected(data, isTransact) ?? [];
  setPhoneList(filtered);
  logPhonePage(eventSource, filtered, isTransact, transactionCategoryId);
}

export function shouldShowLinkToAddPhone(
  isTransact: boolean,
  transactionCategoryId?: string | number,
): JSX.Element | null {
  return isTransact ? (
    <PinWithAddPhone
      type={addPhoneTemplate3}
      pageSource={AMPLITUDE_EVENT_SOURCES.select_phone_page}
      isTransact
      transactionCategoryId={transactionCategoryId}
    />
  ) : null;
}
